export default __webpack_public_path__ + "static/spiritual-christian-paul-2-f1be840a6447b2fc2e243894bcb48a96.jpg";